import { z } from 'zod';

import { ClientSchema } from '@t/api';

export const UserFilterSchema = z.object({
  clientGroup: z.string(ClientSchema),
  department: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  role: z.string().optional(),
});

export type UserFilterForm = z.infer<typeof UserFilterSchema>;
